import styled from "styled-components";

export const HamburgerContainer = styled.div`

@media (min-width: 1024px) {
  display: none;
}
`